<template lang="pug">
  .demographicSlide.grey-background(ref="demographicSlide")
    .max-width-grid
      Receipt.desktop
      h4.black What is the demographic of holiday shoppers?<span class="super"><a href="https://nrf.com/media-center/press-releases/thanksgiving-weekend-multichannel-shopping-almost-40-percent-over-last" target="_blank">1</a></span>
      p Older millennials and Gen Xers (35&#8212;44 years old) are<br>the biggest holiday spenders, at
      h1 $<span class="count">0</span>
</template>

<script>
import Receipt from '@/assets/img/svgs/receiptBg.svg'
import { Power3 } from 'gsap'

export default {
  name: 'demographicSlide',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const topReceipt = this.$el.querySelector('.topRecipt')
    const btmReceipt = this.$el.querySelector('.btmRecipt')
    const countUp = this.$el.querySelector('.count')
    const countVal = { val: 0 } , NewVal = 413.05

  TweenLite

    this.timeline = new TimelineLite({ paused: true })
      .fromTo(topReceipt, 1, { y: -100, opacity: 0 } , { y: 0, opacity: 1 })
      .fromTo(btmReceipt, 1, { y: 100, opacity: 0} , {  y: 0, opacity: 1 }, '-=0.75')
      .to(countVal,2,{ val:NewVal, onUpdate: () => { countUp.innerHTML=countVal.val.toFixed(2) }, ease: Power3.easeIn }, '-=1.25')
  },
  computed: {
  },
  methods: {
    playAnimation () {
      this.timeline.seek(0)
      this.timeline.play()
    },
  },
  components: {
    Receipt,
  },
}
</script>

<style scoped lang="scss">
.demographicSlide {
  height: 41rem;
  padding-top: 5rem;
  text-align: center;
  h4 {
    padding-bottom: 7.56rem;
  }
  p {
    padding-bottom: 4.62rem;
  }

  svg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }

  @media #{$mobile} {
    h4 {
      padding-bottom: 6rem;
    }
    p {
      padding-bottom: 2rem;
    }
  }
}
</style>
